<template>
  <div class="box">
    <div class="logoBox">
      <div class="container">
        <router-link :to="{ path: '/' }" class="logoImg">
          戏游互动
        </router-link>
        <div class="fr navBox">
          <a href="#/" class="router-link-active">首页</a>
          <a href="#/news" class="router-link-active">行业资讯</a>
          <a href="#/about" class="router-link-active">联系我们</a>
          <a href="#/help" class="router-link-active">帮助中心</a>
        </div>
      </div>
    </div>
    <div class="content" style="max-width: 900px;">
    <!-- <p class="title">帮助中心</p> -->
   <p data-v-0647af33="" class="title">帮助中心</p>
   <p style="margin-bottom: 10px;">a: 问：取消订单/退货后怎么退款？</p>
   <p style="margin-bottom: 10px;">b: 答：商品出库前：若您在商品未出库前提交取消申请，会在30分钟后完成退款审核。商品送往配送站前：若您在商品已经出库，等待装车送往配送站前提交取消申请，会在商品退库之后系统会为您退款。商品送往配送站的途中：若您在订单商品已经装车送往配送站的途中提交取消申请，会在商品退库之后系统会为您退款。拒收订单：订单拒收后，系统会自动帮您提交取消申请，商品退库之后系统会为您退款。若超过时效未完成退款审核，请联系客服咨询。</p>
   <p style="margin-bottom: 10px;">c: 问：已绑定的手机号不能正常使用，如何修改手机号？</p>
   <p style="margin-bottom: 10px;">d: 答：若已绑定的手机无法正常使用，请点击通过“银行卡信息验证+手机验证码”/“支付密码验证+手机验证码”/“银行卡信息验证+支付密码”任意一种方式进行修改绑定手机</p></div>
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <span>购买资讯费用,1元/条</span>
      <div class="fr">
        <el-button type="primary" @click="goPay">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { dialog, button } from "element-ui";
export default {
  components: {
    elDialog: dialog,
    elButton: button,
  },
  data() {
    return {
      mockData: {},
      dialogVisible: false,
    };
  },
  methods: {
    async getMockData() {
      let res = (await import("../mall/home/mock/home.js")).default;
      this.mockData = res.data.news;
    },
    goPay() {
      this.dialogVisible = false;
       this.$router.push("/pay");
    },
    goHome() {
      this.$router.push("/");
    },
  },
  created() {
    this.getMockData();
  },
};
</script>
<style scoped>
.box {
  min-height: 100vh;
  background-color: #fff;
}
.logoBox {
  background-color: #fff;
  width: 100%;
  padding: 15px 0;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.logoImg {
  width: 120px;
  height: 70px;
  margin-left: 50px;
  font-family: PingFangSC-Medium, PingFang SC;
  color: #66beb2;
  font-size: 20px;
  vertical-align: middle;
}
.content {
  padding: 20px 0 0 200px;
}
li {
  border-top: 1px solid #dddfe3;
  height: 150px;
  width: 80%;
}
.title {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 30px;
  margin-bottom: 20px;
}
.line-title {
  font-family: PingFangSC-Medium, PingFang SC;
  font-size: 30px;
  margin-bottom: 20px;
}
.line-new {
  line-height: 20px;
}
.more {
  display: inline-block;
  height: 15px;
  line-height: 15px;
  border-radius: 20px;
  padding: 0 5px;
  border: 1px solid #4593ff;
  font-size: 12px;
  color: #4593ff;
  margin-left: 10px;
}
.fr{
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/help/help.vue